import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'publisherDeactivationReason' })
export class PublisherDeactivationReasonPipe implements PipeTransform {
  // Keys are lowercase; lookup normalizes input so IVT_MFA, ivt_mfa, Ivt_Mfa all match.
  static readonly DISPLAY_OVERRIDES: Record<string, string> = {
    ivt_mfa: 'IVT / MFA',
  };

  // Pre-formatted display values that downstream pipes (e.g. formatText's enumToTitleCase)
  // must leave untouched, otherwise they'd be re-title-cased back to "Ivt / mfa".
  static readonly DISPLAY_OVERRIDE_VALUES: ReadonlySet<string> =
    new Set(Object.values(PublisherDeactivationReasonPipe.DISPLAY_OVERRIDES));

  transform(value: string | null | undefined): string {
    return formatPublisherDeactivationReason(value);
  }
}

export const PUBLISHER_DEACTIVATION_REASON_DISPLAY_OVERRIDE_VALUES =
  PublisherDeactivationReasonPipe.DISPLAY_OVERRIDE_VALUES;

const UNDERSCORE_REGEX = /_/g;
const WORD_INITIAL_LETTER_REGEX = /\b\w/g;

export function formatPublisherDeactivationReason(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  const override = PublisherDeactivationReasonPipe.DISPLAY_OVERRIDES[value.toLowerCase()];
  if (override) {
    return override;
  }
  return value
    .toLowerCase()
    .replace(UNDERSCORE_REGEX, ' ')
    .replace(WORD_INITIAL_LETTER_REGEX, (c) => c.toUpperCase());
}
